'use client';

import { useState, useEffect } from 'react';

export default function BuildBadge() {
  const [visible, setVisible] = useState(false);
  const hash = process.env.NEXT_PUBLIC_GIT_HASH || 'dev';

  useEffect(() => {
    // Show if ?debug in URL
    if (window.location.search.includes('debug')) {
      setVisible(true);
    }

    // Toggle with Ctrl+Shift+V
    const handler = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'V') {
        setVisible(v => !v);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 8,
        right: 8,
        zIndex: 9999,
        background: 'rgba(0,0,0,0.7)',
        color: '#94a3b8',
        fontSize: 10,
        fontFamily: 'monospace',
        padding: '3px 8px',
        borderRadius: 4,
        cursor: 'pointer',
        userSelect: 'all',
      }}
      title="Git commit hash"
      onClick={() => navigator.clipboard?.writeText(hash)}
    >
      {hash}
    </div>
  );
}
